module.exports = __webpack_public_path__ + "media/ka.c755e831.mp3";